import { css } from '@emotion/core';
import { media, tokens, shadow } from '@domain-group/fe-brary';
var colors = tokens.colors,
  shadows = tokens.shadows;
export var cardsContainer = {
  name: "79elbk",
  styles: "position:relative;"
};
export var cardWindow = {
  name: "1cdw6f4",
  styles: "position:relative;width:100%;display:flex;flex-direction:row;overflow:auto hidden;-ms-overflow-style:none;scrollbar-width:none;"
};
export var cardList = {
  name: "eqff0w",
  styles: "display:flex;flex-direction:row;::-webkit-scrollbar{display:none;}"
};
var scrollBtn = /*#__PURE__*/css("position:absolute;top:50%;transform:translateY(-50%);background:none;border:0;outline:0;width:40px;height:40px;background-color:", colors.neutral.surface.default, ";box-shadow:", shadow(shadows.elevation4), ";border-radius:50%;z-index:2;transition:opacity 0.3s;");
export var scrollBtnLeft = /*#__PURE__*/css(scrollBtn, " left:10px;");
export var scrollBtnRight = /*#__PURE__*/css(scrollBtn, " right:10px;");
export var scrollButtonIcon = /*#__PURE__*/css("display:flex;color:", colors.neutral.medium.default, ";padding:0;width:30px;height:16px;cursor:pointer;", media('>=desktop'), "{&:hover{color:", colors.interactive.base.default, ";}}");